module.exports = __webpack_public_path__ + "img/en.957a4b2b.png";